import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BasePage } from '../../../../shared/components/base-page.component';
import { CheckSubscriptionApi } from '../../../../shared/Subscription/Api/CheckSubscriptionApi';
import { BehaviorSubject } from 'rxjs';
import { UrlHelper } from '../../../../shared/helpers/UrlHelper';

@Component({
    selector: 'subscribe-return-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './SubscribeReturnPage.html',
    styleUrl: './SubscribeReturnPage.css',
})

export class SubscribeReturnPage implements BasePage, OnInit, OnDestroy
{
    public error$ = new BehaviorSubject<string | null>(null);
    public loading$ = new BehaviorSubject(false);
    public complete$ = new BehaviorSubject(false);
    public dashboardUrl = UrlHelper.AppBaseUrl;

    private cancelled = false;
    private readonly pollIntervalMs = 3000;
    private readonly timeoutMs = 60_000;

    constructor(private checkSubscriptionApi: CheckSubscriptionApi, private route: ActivatedRoute)
    {
    }

    async ngOnInit()
    {
        this.loading$.next(true);
        await this.pollUntilActive();
    }

    ngOnDestroy()
    {
        this.cancelled = true;
    }

    private async pollUntilActive()
    {
        const startTime = Date.now();

        while (!this.cancelled)
        {
            if (Date.now() - startTime >= this.timeoutMs)
            {
                this.loading$.next(false);
                this.error$.next('Subscription activation timed out. Please go back to your Dashboard and try again.');
                return;
            }

            try
            {
                const subscriptionId = this.route.snapshot.paramMap.get('id');
                if (!subscriptionId)
                {
                    this.error$.next('Subscription ID missing');
                }
                const isActive = await this.checkSubscriptionApi.Get(subscriptionId!);

                if (isActive)
                {
                    this.loading$.next(false);
                    this.complete$.next(true);

                    return;
                }
            }
            catch (e)
            {
                // optional: log or ignore transient errors
            }

            await this.delay(this.pollIntervalMs);
        }
    }

    private delay(ms: number): Promise<void>
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
